import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "discover-control__ip-address discover-control__ip-address--default" }
const _hoisted_2 = ["href"]
const _hoisted_3 = {
  key: 0,
  class: "discover-control__loading"
}
const _hoisted_4 = {
  key: 1,
  class: "discover-control__ip-address"
}
const _hoisted_5 = ["href"]

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { BfLoader } from '@finetic/bikefitting-ui'
import {
  NConfigProvider,
  NInput,
  NInputGroup,
  NForm,
  NFormItem,
  useMessage,
  lightTheme,
} from 'naive-ui'
import { BfButton, ButtonType, ButtonState } from '@finetic/bikefitting-ui'
import { discoverResult } from '@/types/discover'
import { useI18n } from 'vue-i18n'
import { useConnectionStore } from '@/store/connectionStore'
import { buildUrl } from '@/utils/url'
import { getConfig } from '@/config'


export default /*@__PURE__*/_defineComponent({
  __name: 'DiscoverControl',
  setup(__props) {

const connectionStore = useConnectionStore()
const message = useMessage()
const router = useRouter()
const { t } = useI18n()

const bikeNo = ref(router.currentRoute.value.query.bikeNo)
const customerId = ref(router.currentRoute.value.query.customerId)
const sessionId = ref(router.currentRoute.value.query.sessionId)

const { discoverIPAddress } = connectionStore

const fitbikeUrl = ref(getConfig('VUE_APP_FITBIKE_URL'))
const loading = ref(false)
const macAddress = ref('')
const ipAddresses = ref<discoverResult[]>([])

// Remove the local buildUrl function and use the imported one
const getUrl = (baseUrl: string) =>
  buildUrl(baseUrl, {
    bikeNo: bikeNo.value as string,
    customerId: customerId.value as string,
    sessionId: sessionId.value as string,
  })

const discover = () => {
  loading.value = true

  discoverIPAddress(macAddress.value)
    .then((data: discoverResult[]) => {
      if (data && data.length > 0) {
        ipAddresses.value = data
        message.success(t('connection.discover.found'))
      } else {
        ipAddresses.value = []
        message.warning(t('connection.discover.noresult'))
      }
    })
    .finally(() => {
      loading.value = false
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NConfigProvider), { theme: _unref(lightTheme) }, {
    default: _withCtx(() => [
      _createVNode(_unref(NForm), {
        "label-placement": "top",
        class: "discover-control"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: getUrl(fitbikeUrl.value ?? '')
                }, [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('connection.discover.continue')), 1)
                ], 8, _hoisted_2)
              ])
            ])
          ]),
          _createVNode(_unref(NFormItem), {
            label: _unref(t)('connection.discover.info')
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInputGroup), {
                onKeyup: _withKeys(discover, ["enter"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInput), {
                    value: macAddress.value,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((macAddress).value = $event)),
                    placeholder: _unref(t)('connection.discover.macaddress'),
                    onKeypress: _cache[1] || (_cache[1] = ($event: any) => (ipAddresses.value = []))
                  }, null, 8, ["value", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_unref(BfButton), {
                state: _unref(ButtonState).Enabled,
                type: _unref(ButtonType).Outlined,
                style: {"margin-left":"12px"},
                onClick: discover
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('connection.discover.discover')), 1)
                ]),
                _: 1
              }, 8, ["state", "type"])
            ]),
            _: 1
          }, 8, ["label"]),
          (loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_unref(BfLoader))
              ]))
            : _createCommentVNode("", true),
          (ipAddresses.value.length && !loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ipAddresses.value, (result) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: result.InternalIp
                    }, [
                      _createElementVNode("a", {
                        href: getUrl(result.InternalIp)
                      }, [
                        _createElementVNode("div", null, _toDisplayString(result.InternalIp), 1),
                        _createElementVNode("span", null, _toDisplayString(result.MacAddress), 1)
                      ], 8, _hoisted_5)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["theme"]))
}
}

})